import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 p-2" }
const _hoisted_2 = { class: "flex gap-1 flex-wrap" }
const _hoisted_3 = { class: "flex flex-col gap-1 w-52" }
const _hoisted_4 = { class: "flex flex-col gap-1 w-52" }
const _hoisted_5 = { class: "flex flex-col gap-1 w-52" }
const _hoisted_6 = { class: "flex flex-col gap-1 w-52" }

import TRSearchableSelect from "@/components/Base/v2/TRSearchableSelect.vue";
import {computed, nextTick, onMounted, ref} from "vue";
import {mutation, query} from "@/graphql";
import TRButton from "@/components/Base/v2/TRButton.vue";
import {eventBus} from "@/application/EventBus";
import SignalBus from "@/application/SignalBus";

// Refs für die Select-Komponenten

export default /*@__PURE__*/_defineComponent({
  __name: 'PlaceProductFromOtherMagazine',
  props: {
  page: {
    type: Array,
    required: true
  },
  virtualId: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const projectSelect = ref(null);
const magazineSelect = ref(null);
const marketSelect = ref(null);
const productSelect = ref(null);

// Datenlisten
const projekts = ref([]);
const magazines = ref([]);
const markets = ref([]);
const articles = ref([]);

// Ausgewählte Werte
const projectId = ref(0);
const magazineId = ref(0);
const marketId = ref(0);
const productId = ref(0);
const pagePosition = ref(0);

// Status für die Validierung
const isLoadingMagazines = ref(false);
const isLoadingMarkets = ref(false);
const isLoadingArticles = ref(false);

// Validierung für den Submit-Button
const isFormValid = computed(() => {
  return projectId.value && magazineId.value && productId.value;
});

const props = __props;

onMounted(async () => {
  await fetchProjects();
});

// Projekt-Änderung Handling
async function onProjectChange(newProjectId) {
  console.log("Projekt geändert:", newProjectId);

  // Zurücksetzen und Leeren der abhängigen Selects
  forceResetSelect('magazine');
  forceResetSelect('market');
  forceResetSelect('product');

  // Laden der neuen Magazine
  if (newProjectId && newProjectId !== 0) {
    await fetchMagazines(newProjectId);
  }
}

// Magazin-Änderung Handling
async function onMagazineChange(newMagazineId) {
  console.log("Magazin geändert:", newMagazineId);

  // Zurücksetzen und Leeren der abhängigen Selects
  forceResetSelect('market');
  forceResetSelect('product');

  // Laden der abhängigen Daten
  if (newMagazineId && newMagazineId !== 0) {
    await Promise.all([
      fetchMarkets(newMagazineId),
      fetchProducts(newMagazineId)
    ]);
  }
}

// Markt-Änderung Handling
async function onMarketChange(newMarketId) {
  console.log("Markt geändert:", newMarketId);

  // Zurücksetzen des Artikel-Selects
  forceResetSelect('product');

  // Neu laden der Produkte
  if (magazineId.value && magazineId.value !== 0) {
    await fetchProducts(magazineId.value, newMarketId);
  }
}

// Forciertes Zurücksetzen eines Selects
function forceResetSelect(selectType) {
  // Je nach Typ den richtigen Ref und Value zurücksetzen
  let selectRef = null;

  switch(selectType) {
    case 'magazine':
      magazineId.value = 0;
      magazines.value = [];
      selectRef = magazineSelect.value;
      break;
    case 'market':
      marketId.value = 0;
      markets.value = [];
      selectRef = marketSelect.value;
      break;
    case 'product':
      productId.value = 0;
      articles.value = [];
      selectRef = productSelect.value;
      break;
  }

  // Reset-Methode der Komponente aufrufen, falls verfügbar
  nextTick(() => {
    if (selectRef && typeof selectRef.reset === 'function') {
      selectRef.reset();
    }
  });
}

// Daten-Abrufe
async function fetchProjects() {
  const [data, err] = await query.getProjectsWithIdAndName();
  if (err) {
    console.error("Fehler beim Laden der Projekte:", err);
    return;
  }
  projekts.value = data || [];
}

async function fetchMagazines(projectId) {
  try {
    isLoadingMagazines.value = true;
    const [data, err] = await query.getMagazinesWithIdAndName(projectId);
    if (err) {
      console.error("Fehler beim Laden der Magazine:", err);
      return;
    }
    magazines.value = data || [];
  } finally {
    isLoadingMagazines.value = false;
  }
}

async function fetchMarkets(magazineId) {
  try {
    isLoadingMarkets.value = true;
    const [data, err] = await query.getMarketsWithIdAndName(magazineId);
    if (err) {
      console.error("Fehler beim Laden der Märkte:", err);
      return;
    }
    markets.value = data || [];
  } finally {
    isLoadingMarkets.value = false;
  }
}

async function fetchProducts(magazineId, marketId = 0, pagePosition = 0) {
  try {
    isLoadingArticles.value = true;
    const [data, err] = await query.getProductsWithIdAndName(magazineId, marketId, pagePosition);
    if (err) {
      console.error("Fehler beim Laden der Artikel:", err);
      return;
    }
    articles.value = data || [];
  } finally {
    isLoadingArticles.value = false;
  }
}

async function articleLink() {
  if (!isFormValid.value) {
    console.log("Formular ist nicht gültig");
    return;
  }

  try {
    const [data, err] = await mutation.articleLink(
        props.virtualId,
        props.page.pageId,
        magazineId.value,
        pagePosition.value || 0,
        marketId.value || 0,
        productId.value
    );

    if (err) {
      console.error("Fehler beim Hinzufügen des Artikels:", err);
      return;
    }

    // Dialog schließen und Seite neu laden
    eventBus.closeModal();
    SignalBus.emit("reload-page");
  } catch (e) {
    console.error("Unerwarteter Fehler:", e);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-sm text-trader-text" }, "Project auswählen", -1)),
        _createVNode(TRSearchableSelect, {
          ref_key: "projectSelect",
          ref: projectSelect,
          modelValue: projectId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((projectId).value = $event)),
          items: projekts.value,
          placeholder: "Projekt suchen...",
          onChange: onProjectChange
        }, null, 8, ["modelValue", "items"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-sm text-trader-text" }, "Magazine auswählen", -1)),
        _createVNode(TRSearchableSelect, {
          ref_key: "magazineSelect",
          ref: magazineSelect,
          modelValue: magazineId.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((magazineId).value = $event)),
          items: magazines.value,
          placeholder: "Magazine suchen...",
          onChange: onMagazineChange,
          disabled: !projectId.value || projectId.value === 0
        }, null, 8, ["modelValue", "items", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-sm text-trader-text" }, "Articlenummer auswählen", -1)),
        _createVNode(TRSearchableSelect, {
          ref_key: "productSelect",
          ref: productSelect,
          modelValue: productId.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((productId).value = $event)),
          items: articles.value,
          placeholder: "Artikelnummer suchen...",
          disabled: !magazineId.value || magazineId.value === 0
        }, null, 8, ["modelValue", "items", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-sm text-trader-text" }, "Markt auswählen (Optional)", -1)),
        _createVNode(TRSearchableSelect, {
          ref_key: "marketSelect",
          ref: marketSelect,
          modelValue: marketId.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((marketId).value = $event)),
          items: markets.value,
          placeholder: "Markt suchen...",
          onChange: onMarketChange,
          disabled: !magazineId.value || magazineId.value === 0
        }, null, 8, ["modelValue", "items", "disabled"])
      ])
    ]),
    _createVNode(TRButton, {
      text: "Artikel Hinzufügen",
      onClick: articleLink,
      disabled: !isFormValid.value
    }, null, 8, ["disabled"])
  ]))
}
}

})